var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.holiday
    ? _c("div", [
        _vm._v("\n  Você escolheu o dia\n  "),
        _c("b", [_vm._v(_vm._s(_vm._f("formatDay")(_vm.holiday.day)))]),
        _vm._v(", neste dia não haverá suporte e atendimento!\n  "),
        _c("b", [_vm._v("Imprevistos")]),
        _vm._v(",\n  "),
        _c("b", [_vm._v("reagendamentos")]),
        _vm._v(" ou\n  "),
        _c("b", [_vm._v("cancelamentos")]),
        _vm._v(" nesse dia serão tratados\n  "),
        _c("b", [_vm._v("antes")]),
        _vm._v(" ou no\n  "),
        _c("b", [_vm._v("próximo dia útil")]),
        _vm._v(". Você está ciente e deseja prosseguir?\n")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e57f63b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e57f63b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Warnings/Holiday.vue
// module id = null
// module chunks = 